module.exports = __webpack_public_path__ + "static/4-c39321e0dbc27a0dac4d3f078e664366.png";